import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { ActionHandlerFunction, Sort } from "@preveil-api";
import { Account, SearchNode, EntryItem, DriveSearchFilterSet, DriveSearchFilters, SearchErrorCodes, sortBy, SearchFieldType } from "src/common";
import { SearchResults, SearchTypeFilter, SearchScopeFilter, SearchFooter } from ".";

type AllProps = {
  current_account: Account;
  search_term?: string;
  results?: SearchNode[];
  sort: Sort<keyof SearchNode>;
  filters: DriveSearchFilterSet;
  progress: number;
  loading: boolean;
  paused: boolean;
  selected_folders: EntryItem[];
  error?: SearchErrorCodes;
  handleAction: ActionHandlerFunction;
}

function SearchDropdownComponent(props: AllProps) {
  const { current_account, selected_folders, search_term, paused, loading, results, sort, filters, progress, error, handleAction } = props;
  const [filtered_results, setFilteredResults] = useState<SearchNode[] | undefined>(results);

  useEffect(() => {
    const _new_results = !!results ? DriveSearchFilters.applyFilters(results, filters, sort) : results;
    setFilteredResults(_new_results);
  }, [results, filters]);

  useEffect(() => {
    if (!!filtered_results) {
      const sorted_results = sortBy(filtered_results, sort, sort.field === SearchFieldType.last_modification_date);
      setFilteredResults(sorted_results);
    }
  }, [sort]);

  return <div className="search-results">
    <Row>
      <Col sm="8" className="results">
        <SearchResults
          current_account={current_account}
          search_term={search_term}
          sort={sort}
          error={error}
          results={filtered_results}
          progress={progress}
          paused={paused}
          searching={!paused && loading}
          handleAction={handleAction} />
      </Col>
      <Col sm="4" className="filters">
        {
          selected_folders.length > 0 &&
          <SearchScopeFilter
            selected_folders={selected_folders}
            searching={!paused && loading}
            handleAction={handleAction} />
        }
        <SearchTypeFilter
          searching={!paused && loading}
          handleAction={handleAction} />
      </Col>
    </Row>
    <SearchFooter
      search_term={search_term}
      counts={filtered_results?.length || 0}
      progress={progress}
      error={error}
      handleAction={handleAction} />
  </div>;
}

export default React.memo(SearchDropdownComponent);
